import { useQuery } from '@tanstack/react-query';
import { getUserAvailability } from 'api/requests/availability';

export const useGetAvailabilityByUserId = (userId: string) => {
  return useQuery({
    queryKey: ['availabilityByUserId', userId],
    queryFn: () => getUserAvailability(userId),
  });
};
